import * as dashboardDesignerActions from "../actions/dashboard-designer";
import { createEntityAdapter } from "@ngrx/entity";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DashboardItem } from "../../dashboards/models/dashboard-item";
import { HttpErrorResponse } from '@angular/common/http';
import { EntityState } from "@ngrx/entity";

export const dashboardItemAdapter = createEntityAdapter<DashboardItem>();

export interface DashboardDesignerState extends EntityState<DashboardItem> {
  loading: boolean;
  error: HttpErrorResponse;
  currentDashboard: string;
  currentProfile: number;
  designerMode: boolean;
};

const INITIAL_STATE: DashboardDesignerState = dashboardItemAdapter.getInitialState({
  loading: false,
  error: null,
  currentDashboard: null,
  currentProfile: null,
  designerMode: null,
});

export function reducer(
  state: DashboardDesignerState = INITIAL_STATE,
  action: dashboardDesignerActions.Actions): DashboardDesignerState {
  switch (action.type) {
    case dashboardDesignerActions.LOAD:
      return {
        ...state,
        loading: true
      };

    case dashboardDesignerActions.LOAD_COMPLETE:
      {
        return dashboardItemAdapter.setAll(action.payload, { ...state, loading: false });
      }

    case dashboardDesignerActions.LOAD_ERROR:
      {
        return { ...state, loading: false, error: action.payload };
      }
    case dashboardDesignerActions.SET_CURRENT_DASHBOARD:
      {
        return { ...state, currentDashboard: action.payload };
      }
    case dashboardDesignerActions.SET_CURRENT_PROFILE:
      {
        return { ...state, currentProfile: action.payload };
      }
    case dashboardDesignerActions.RESET:
      return {
        ...state,
        loading: true
      };
    case dashboardDesignerActions.ENTER_DESIGNER:
      return {
        ...state,
        designerMode: true
      };
    case dashboardDesignerActions.EXIT_DESIGNER:
      return {
        ...state,
        designerMode: null
      };
    default:
      return state;
  }
};

